import React from "react";
import LayoutBreadCrum from "screen/00_Nav/layout/layout_bread_crum";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import "./section_container.css";

const SectionCointaner = (props) => {
  // -------------------------- VAR -----------------------------
  const children = props.children || null;
  const breadCrum = props.breadCrum || null;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  const renderBreadcrum = () => {
    return <LayoutBreadCrum data={breadCrum} />;
  };

  // -------------------------- MAIN ----------------------------
  return (
    <div className="section-container">
      {renderBreadcrum()}
      <div className="section-content">{children}</div>
    </div>
  );
};
export default SectionCointaner;
